import { useEffect } from 'react';
import { useFullscreenStore } from '../FullscreenStore';

export const useFullscreenMode = () => {
  const isFullscreen = useFullscreenStore((state) => state.isFullscreen);
  const setFullscreen = useFullscreenStore((state) => state.setFullscreen);

  // The attribute drives global CSS (--headerHeight override). Cleanup always removes it so pages
  // without NavigationLayout get the header back while the store value persists.
  useEffect(() => {
    if (isFullscreen) {
      document.documentElement.dataset.fullscreen = 'true';
    } else {
      delete document.documentElement.dataset.fullscreen;
    }

    return () => {
      delete document.documentElement.dataset.fullscreen;
    };
  }, [isFullscreen]);

  useEffect(() => {
    if (!isFullscreen) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !e.defaultPrevented) {
        setFullscreen(false);
      }
    };

    window.addEventListener('keydown', onKeyDown);

    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isFullscreen, setFullscreen]);

  return { isFullscreen };
};
